import React from 'react'

import { usePSNavigate } from '../../hooks/usePSNavigate'
import { AppHeader } from '../app/AppHeader'
import { ProductPageV1 } from './ProductPageV1'

export const SetupInventoryPage = () => {
    const navigate = usePSNavigate()
    return (
        <AppHeader title="Inventory" showBackButton={true} middleWidget={null}>
            <div className="pageWrapper">
                <ProductPageV1 completeCallBack={() => navigate(-1)} />
            </div>
        </AppHeader>
    )
}
